export { useSegmentContext as useEvents } from './segmentContext';
export { eventNames, pageNames } from '@sly/core/constants/events';
